import React, {useState, useEffect} from 'react'
import styles from "./FindField.module.css"
import { IoIosSearch, IoIosClose } from "react-icons/io";
import { AiOutlineClose, AiOutlineSearch } from 'react-icons/ai';



export default function FindField({
    searchInput,
    setSearchInput
}) {
  return (
    <div className={styles.searchBlock}>
      <IoIosSearch />
      <input 
        value={searchInput}
        onChange={(e) => setSearchInput(e.target.value)}
      />
      <IoIosClose                 
        onClick={() => setSearchInput("")}
      />
    </div>
  )
}

export const SearchInput = ({ value, onChange, ...props }) => {
  
  const [searchString, setSearchString] = useState('')
  const [firstRender, setFirstRender] = useState(true)

  useEffect(() => {
    !value && setSearchString('')
  }, [value])
  

  useEffect(() => {
    if (!searchString && firstRender) return;
    firstRender && setFirstRender(false)
    const timeout = setTimeout(() => {
      onChange(searchString)
    }, 1000);
    return () => {
      clearTimeout(timeout)
    }
  }, [searchString])
  
  return (
    <div className={styles.searchBlock}>
        <AiOutlineSearch/>
        <input
          value={searchString}
          onChange={e => setSearchString(e.target.value)}
          style={{ width: '80%'}}
          {...props}
        />
        {searchString &&
        <AiOutlineClose onClick={() => setSearchString('')} />}
    </div>
  )
}